import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { groupQueries } from '@/services/groupsManagement/groupsManagement.queries';

export const useGroupDetail = (groupId: string) => {
  const { data, isLoading } = useQuery({
    ...groupQueries.detail(groupId),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
    enabled: !!groupId,
  });

  return { groupDetail: data?.data, isLoading };
};
